import sectionImageWithTextBasicCss from '../css-snippets/section-image-with-text-basic';

const html = `
<style>${sectionImageWithTextBasicCss}</style>
<div class="wrapper-container" id="" data-id="uawgo3" data-attribute="wrapper-container" data-text-color="#000000"
<div class="wrapper-container" id="" data-id="uawgo3" data-attribute="wrapper-container" data-text-color="#000000"
  data-background-color="#ffffff" data-top-padding="true" data-bottom-padding="true"
  style="background-color: #ffffff; color: #000000; --text-color: #000000; --width-image: 200px;">
  <div class="container">
    <div style="display: block;" data-show-title="true" data-attribute="title-content" class="header-content">
      <h2 style="text-align:center;">Your Purchase Is Protected By Our</h2>
      <h2 style="text-align:center;"><span style="color:hsl(30,75%,60%);"><strong>90-Day "Sleep In Peace"
            Guarantee</strong></span></h2>
      <p style="text-align:center;">Here at Haven, we make sure our customers feel safer — or we refund 100% of their
        investment. We're so confident you'll finally sleep knowing your family is protected that we'll bear all the
        risk.</p>
    </div>
    <div data-attribute="wrapper-content" class="wrapper-content" data-background="#fefdf0"
      style="background-color: #fefdf0;">

      <div data-attribute="wrap-img" data-show-img="true" data-width-image="200px" class="wrap-img"
        style="display: flex;">
        <img data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/03/12/image-69b2819679706ac78084398a.png?w=50&h=50&q=80" alt="">
      </div>
      <div data-attribute="description-content" class="description-content">
        <h3 style="text-align:center;"><strong>"Right Now, While You Read This"</strong></h3>
        <p style="text-align:center;"><strong>Right now, a family is breathing poison. Detector glowing green. Kids
            asleep. No idea.</strong></p>
        <p style="text-align:center;">&nbsp;</p>
        <p style="text-align:center;">Some will wake up with headaches. Some won't wake up at all.</p>
        <p style="text-align:center;">This isn't a someday problem. It's a tonight problem.</p>
        <p style="text-align:center;">Do you <i>know</i> your detector works or are you just hoping?</p>
        <p style="text-align:center;">&nbsp;</p>
        <p style="text-align:center;"><strong>Hope isn't protection. Haven is.</strong></p>
        <blockquote>
          <p style="text-align:center;"><i>"I built Haven after my daughter's close call. No family should trust a green
              light that lies."</i> — <strong>James Chen, Founder</strong></p>
        </blockquote>
      </div>
    </div>
  </div>
</div>
`;
export default html;
